type Props = {
    title: string;
    data: any[];
    nameKey: string;
    valueKey: string;
};

const TopListCard = ({ title, data, nameKey, valueKey }: Props) => {
    return (
        <div className="bg-white p-5 rounded-2xl shadow-sm">
            <h2 className="text-lg font-semibold mb-4">{title}</h2>

            <div className="flex flex-col gap-3">
                {data?.map((item, i) => (
                    <div
                        key={i}
                        className="flex justify-between border-b pb-2 text-sm"
                    >
                        <span>{item[nameKey]}</span>
                        <span className="font-semibold">
                            {item[valueKey]} QAR
                        </span>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default TopListCard;